import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import {
  PHOTO_MOMENT_META,
  resolvePhotoMoment,
  type PhotoMoment,
} from "@/lib/photoMoments";

interface PhotoMomentBadgeProps {
  /** Explicit moment when the caller already knows it (e.g. EntryWalkthroughStep). */
  moment?: PhotoMoment | null;
  /** Used to infer moment when no explicit hint is provided. */
  url?: string | null;
  /** Default moment when both hint and inference miss. */
  fallback?: PhotoMoment;
  /** Use short label ("Arrival" / "Cleaning" / "Staging") instead of full. */
  short?: boolean;
  className?: string;
}

export function PhotoMomentBadge({
  moment,
  url,
  fallback,
  short = false,
  className,
}: PhotoMomentBadgeProps) {
  const resolved = resolvePhotoMoment({ url, hint: moment ?? null, fallback });
  const meta = PHOTO_MOMENT_META[resolved];
  return (
    <Badge
      variant="outline"
      className={cn("text-[10px] font-semibold uppercase tracking-wide", meta.badgeClass, className)}
      title={meta.description}
    >
      {short ? meta.shortLabel : meta.label}
    </Badge>
  );
}
